// Namespace "admin" — fragment "promos" (BUG-019).
//
// The keys the promo model gained when `{kind, value: float}` became typed integer cents.
// The pre-existing `promos.*` keys stay in `base.js` — `mergeFragments` throws on a
// duplicate key, so this fragment carries ONLY what is new.
//
// `promos.kind.*` names the discountable kinds. Gift cards and invoices have no key
// here because they have no entry in the whitelist either
// (modules/promos.DISCOUNTABLE_KINDS): a label for a kind that can never be selected is
// how a UI starts promising something the server refuses.
//
// `promos.kind.telehealth` is the ONE exception, and it is a READ-ONLY label. The
// whitelist dropped "telehealth" when consultations moved to per-minute pricing, so it is
// no longer offered as a chip (PromosAdmin's KINDS) — but codes created while it WAS
// whitelisted still name it in their `applies_to`, and that list is rendered from the
// row's own statement. Delete this key and those rows print "promos.kind.telehealth" at
// the practitioner. __tests__/PromosAdmin.appliesTo.test.js pins it for that reason.
export default {
  fr: {
    "promos.percentValue": "Remise (%)",
    "promos.amountValue": "Remise ($)",
    "promos.minSubtotal": "Achat minimum ($, 0 = aucun)",
    "promos.minSubtotalLabel": "dès {value} $ d'achat",
    "promos.appliesTo": "S'applique à",
    "promos.kind.booking": "Rendez-vous",
    "promos.kind.product": "Boutique",
    "promos.kind.program": "Programmes",
    "promos.kind.course": "Cours",
    "promos.kind.pathway": "Parcours",
    "promos.kind.telehealth": "Consultations vidéo",
    "promos.appliesToRequired": "Choisissez au moins un type de vente pour ce code",
    "promos.percentInvalid": "Entrez un pourcentage supérieur à 0 et jusqu'à 100",
    "promos.amountInvalid": "Entrez un montant supérieur à 0",
    "promos.maxUsesInvalid": "Entrez un nombre entier d'utilisations, 0 ou plus (0 = illimité)",
    "promos.minSubtotalInvalid": "Entrez un achat minimum de 0 ou plus",
    "promos.errorDuplicate": "Ce code existe déjà — choisissez-en un autre",
    "promos.codeCharset": "Un code peut contenir des lettres (accents compris), des chiffres, des tirets (-) et des tirets bas (_), sans espace ni autre symbole",
  },
  en: {
    "promos.percentValue": "Discount (%)",
    "promos.amountValue": "Discount ($)",
    "promos.minSubtotal": "Minimum order ($, 0 = none)",
    "promos.minSubtotalLabel": "on orders of ${value}+",
    "promos.appliesTo": "Applies to",
    "promos.kind.booking": "Appointments",
    "promos.kind.product": "Shop",
    "promos.kind.program": "Programs",
    "promos.kind.course": "Courses",
    "promos.kind.pathway": "Pathways",
    "promos.kind.telehealth": "Video consultations",
    "promos.appliesToRequired": "Choose at least one kind this code applies to",
    "promos.percentInvalid": "Enter a percentage above 0 and up to 100",
    "promos.amountInvalid": "Enter an amount greater than 0",
    "promos.maxUsesInvalid": "Enter a whole number of uses, 0 or more (0 = unlimited)",
    "promos.minSubtotalInvalid": "Enter a minimum order of 0 or more",
    "promos.errorDuplicate": "This code already exists — choose another one",
    "promos.codeCharset": "A code may only contain letters (accents included), digits, hyphens (-) and underscores (_), with no spaces or other symbols",
  },
  es: {
    "promos.percentValue": "Descuento (%)",
    "promos.amountValue": "Descuento ($)",
    "promos.minSubtotal": "Compra mínima ($, 0 = ninguna)",
    "promos.minSubtotalLabel": "desde ${value} de compra",
    "promos.appliesTo": "Se aplica a",
    "promos.kind.booking": "Citas",
    "promos.kind.product": "Tienda",
    "promos.kind.program": "Programas",
    "promos.kind.course": "Cursos",
    "promos.kind.pathway": "Itinerarios",
    "promos.kind.telehealth": "Consultas por video",
    "promos.appliesToRequired": "Elige al menos un tipo de venta para este código",
    "promos.percentInvalid": "Ingresa un porcentaje mayor que 0 y hasta 100",
    "promos.amountInvalid": "Ingresa un monto mayor que 0",
    "promos.maxUsesInvalid": "Ingresa un número entero de usos, 0 o más (0 = ilimitado)",
    "promos.minSubtotalInvalid": "Ingresa una compra mínima de 0 o más",
    "promos.errorDuplicate": "Este código ya existe — elige otro",
    "promos.codeCharset": "Un código solo puede contener letras (con acentos), números, guiones (-) y guiones bajos (_), sin espacios ni otros símbolos",
  },
};
